import { useFt } from 'hooks'
import { constants } from 'helpers'
import { Meta } from 'components/dataDisplay'

import useGetSeoData from './util/useGetSeoData'
import checkIsNotEmptyParams from './util/checkIsNotEmptyParams'


type PageMetaProps = {
  defaultTitle?: string | Intl.Message
  defaultMetaTitle?: string | Intl.Message
  defaultDescription?: string | Intl.Message
  // should be one to deduplicate pages in search
  pathname?: string
  withoutTitleTemplate?: boolean
  keywords?: string
}

const PageMetaComponent: React.FunctionComponent<PageMetaProps> = (props) => {
  const { defaultTitle, defaultDescription, pathname, withoutTitleTemplate, keywords, defaultMetaTitle } = props
  const seoData = useGetSeoData()

  if (checkIsNotEmptyParams(props) || checkIsNotEmptyParams(seoData)) {
    const { metaTitle, metaDescription } = seoData

    const title = metaTitle || defaultTitle
    const description = metaDescription || defaultDescription

    return (
      <Meta
        title={title}
        metaTitle={defaultMetaTitle}
        metaDescription={description}
        pathname={pathname}
        withoutTitleTemplate={withoutTitleTemplate}
        keywords={keywords}
      />
    )
  }

  return null
}

const PageMeta: React.FunctionComponent<PageMetaProps> = (props) => {
  const isSeoStrapiEnabled = useFt(constants.features.seoStrapi)

  if (isSeoStrapiEnabled) {
    return (
      <PageMetaComponent {...props} />
    )
  }

  return null
}

export default PageMeta
